import { BrowserPhoneState } from "./telephonyTypes";

export const getPhoneStatusPresentation = (state, t) => {
  switch (state) {
    case BrowserPhoneState.REGISTERED:
      return {
        label: t("ccPhoneStatusReady"),
        className: "bg-emerald-50 text-emerald-800 border-emerald-200",
      };
    case BrowserPhoneState.CONNECTING:
      return {
        label: t("ccGlobalDialerConnecting"),
        className: "bg-blue-50 text-blue-800 border-blue-200",
      };
    case BrowserPhoneState.INCOMING_CALL:
    case BrowserPhoneState.INCOMING_CONNECTING:
      return {
        label: t("ccGlobalDialerIncoming"),
        className: "bg-blue-50 text-blue-800 border-blue-200",
      };
    case BrowserPhoneState.OUTGOING_CALL:
    case BrowserPhoneState.ACTIVE_CALL:
    case BrowserPhoneState.HOLD:
      return {
        label: t("ccGlobalDialerOnCall"),
        className: "bg-emerald-50 text-emerald-800 border-emerald-200",
      };
    case BrowserPhoneState.REGISTRATION_FAILED:
      return {
        label: t("ccPhoneStatusUnavailable"),
        className: "bg-amber-50 text-amber-900 border-amber-200",
      };
    case BrowserPhoneState.FAILED:
    case BrowserPhoneState.ENDED:
      return {
        label: t("ccPhoneStatusEnded"),
        className: "bg-slate-50 text-slate-700 border-slate-200",
      };
    default:
      return {
        label: t("ccPhoneStatusOffline"),
        className: "bg-slate-50 text-slate-600 border-slate-200",
      };
  }
};
